import { getStoredMirror } from '../hooks/useAuth';

/**
 * Дизайн-темы кабинетов. Тема выбирается по зеркалу сессии и ставится атрибутом
 * `data-theme` на корень страницы — `index.css` переопределяет в этой области
 * CSS-переменные токенов. `default` — исходный дизайн, своего CSS у него нет.
 *
 * Экран входа всегда в `default`: зеркало известно только из ответа `auth`.
 */
export type ThemeId = 'default' | 'industrial';

/** Зеркала без записи — исходный дизайн. */
const MIRROR_THEMES: Record<string, ThemeId> = {
  om: 'industrial',
};

export function themeForMirror(mirrorId: string): ThemeId {
  return MIRROR_THEMES[mirrorId] ?? 'default';
}

export function getSessionTheme(): ThemeId {
  return themeForMirror(getStoredMirror().id);
}
